module.exports = __webpack_public_path__ + "static/media/machha.d66ff131.ogg";